import { IApplicationState } from '../../types/redux';

export const selectMyHomeShowTrap = (state: IApplicationState): boolean => {
  return state.myHome.showTrap;
};
